export enum PageKey {
  landing = 'landing',
  tutorials = 'tutorials',
  pricing = 'pricing',
  privacyPolicy = 'privacyPolicy',
  termsOfService = 'termsOfService',
  lessonPlan = 'lessonPlan',
  objective = 'objective',
  quizMakerSingle = 'quizMakerSingle',
  activities = 'activities',
  subjectExtention = 'subjectExtention',
  analogyContextualizer = 'analogyContextualizer',
  dailyLessonLog = 'dailyLessonLog',
  catchUpFridays = 'catchUpFridays',
  summativeTest = 'summativeTest',
  cerebroLessonPlan = 'lpCerebroTeachingGuide',
  topicExplorer = 'topicExplorer',
  energizer = 'energizer',
  elif = 'elif',
  photoBooth = 'photoBooth',
  unitPlan = 'unitPlan',
  pptMaker = 'pptMaker',
  genericUnpacking = 'genericUnpacking',
  iplan = 'iplan',
  iplanObjective = 'iplanObjective',
  multigradeLessonPlan = 'multigradeLessonPlan',
}

export enum LessonPlanProperties {
  lessonFormat = 'lpLessonFormat',
  subject = 'lpSubject',
  gradeLevel = 'lpGradeLevel',
  objective = 'lpObjective',
  language = 'lpLanguage',
  objective2 = 'lpObjective2',
  objective3 = 'lpObjective3',
  objective4 = 'lpObjective4',
  feature = 'feature',
  time = 'time',
  modality = 'modality',

  // AmericanLP
  curriculumFramework = 'lpCurriculumFramework',
  specificStandards = 'lpSpecificStandards',
  strategies = 'lpStrategies',

  //Montessori specific fields
  title = 'lpTitle',
  classProgram = 'lpClassProgram',
  materials = 'lpMaterials',
  prerequisites = 'lpPrerequisites',
  keyArea = 'lpKeyArea',
  keyArea2 = 'lpKeyArea2',
  keyArea3 = 'lpKeyArea3',
}

export enum MultigradeLessonPlanProperties {
  lessonFormat = 'mgLessonFormat',
  subject = 'mgSubject',
  gradeLevel = 'mgGradeLevel',
  objective = 'mgObjective',
  language = 'mgLanguage',
  objective2 = 'mgObjective2',
  objective3 = 'mgObjective3',
  feature = 'feature',
}

export enum DllProperties {
  format = 'dllFormat',
  subject = 'dllSubject',
  gradeLevel = 'dllGradeLevel',
  objectives = 'dllObjectives',
  language = 'dllLanguage',
}

export enum LessonPlanV2Properties {
  lessonFormat = 'lessonFormat',
  subject = 'subject',
  gradeLevel = 'gradeLevel',
  objective = 'objective',
  objective2 = 'objective2',
  objective3 = 'objective3',
  language = 'language',
  time = 'time',
}

export enum ObjectiveProperties {
  subject = 'objSubject',
  gradeLevel = 'objGradeLevel',
  competency = 'objCompetency',
  language = 'objLanguage',
  cognitiveVerbs = 'objCognitiveVerbs',
  affectiveVerbs = 'objAffectiveVerbs',
  psychomotorVerbs = 'objPsychomotorVerbs',

  // New affective fields
  affectiveValuesVerbs = 'objAffectiveValuesVerbs',
  affectiveValuesVerbs2 = 'objAffectiveValuesVerbs2',
  affectiveValuesVerbs3 = 'objAffectiveValuesVerbs3',
  affectiveAttitudesVerbs = 'objAffectiveAttitudesVerbs',
  affectiveAttitudesVerbs2 = 'objAffectiveAttitudesVerbs2',
  affectiveAttitudesVerbs3 = 'objAffectiveAttitudesVerbs3',
  valuesList = 'objValuesList',
  valuesList2 = 'objValuesList2',
  valuesList3 = 'objValuesList3',
  attitudesList = 'objAttitudesList',
  attitudesList2 = 'objAttitudesList2',
  attitudesList3 = 'objAttitudesList3',

  // AmericanObjective
  curriculumFramework = 'objCurriculumFramework',
  specificStandards = 'objSpecificStandards',
  objectives = 'objObjectives',
}

export enum QuizMakerSingleProperties {
  subject = 'quizSubject',
  gradeLevel = 'quizGradeLevel',
  language = 'quizLanguage',
  topic = 'quizTopic',
  assessmentType = 'quizAssessmentType',
  quantityOfQuestions = 'quizQuantityOfQuestions',
  additionalInformation = 'quizAdditionalInformation',

  //default
  time = 'quizTime',
  difficulty = 'quizDifficulty',
  number = 'quizNumber',

  //American
  curriculumFramework = 'quizCurriculumFramework',
  specificStandards = 'quizSpecificStandards',
  objective = 'quizObjective',
  objective2 = 'quizObjective2',
  objective3 = 'quizObjective3',
  strategies = 'quizStrategies',
}

export enum ActivitiesSingleProperties {
  subject = 'subject',
  gradeLevel = 'gradeLevel',
  language = 'language',
  objective = 'objective',
  difficulty = 'difficulty',
  materials = 'materials',
  time = 'time',
  curriculumFramework = 'curriculumFramework',
  specificStandards = 'specificStandards',
  strategies = 'strategies',
}
export enum SubjectExtensionsProperties {
  subject = 'seSubject',
  gradeLevel = 'seGradeLevel',
  objective = 'seObjective',
  language = 'seLanguage',
}

export enum AnalogyContextualizerProperties {
  subject = 'subject',
  gradeLevel = 'gradeLevel',
  referenceText = 'referenceText',
  language = 'language',
}

export enum CatchUpFridaysProperties {
  subject = 'subject',
  gradeLevel = 'gradeLevel',
  quarterlyTheme = 'quarterlyTheme',
  subTheme = 'subTheme',
  sessionObjectives = 'sessionObjectives',
  language = 'language',
  feature = 'feature',
}

export enum SummativeTestProperties {
  subject = 'subject',
  gradeLevel = 'gradeLevel',
  language = 'language',
  topics = 'topics',
  format = 'format',
  curriculum = 'curriculum',
  assessmentTypes = 'assessmentTypes',
  standard = 'stSpecificStandards',
  curriculumFramework = 'stCurriculumFramework',
  strategies = 'strategies',
}

export enum CerebroLessonPlanProperties {
  courseTitle = 'courseTitle',
  gradeLevel = 'gradeLevel',
  courseTopic = 'courseTopic',
  contentStandard = 'contentStandard',
  performanceStandard = 'performanceStandard',
  learningCompetencies = 'learningCompetencies',
  language = 'language',
}

export enum TopicExplorerProperties {
  topic = 'topic',
  explorerType = 'explorerType',
  subject = 'teSubject',
  gradeLevel = 'teGradeLevel',
  itemToUnpack = 'itemToUnpack',
}
export enum EnergizerProperties {
  gradeLevel = 'enGradeLevel',
  topic = 'enTopic',
}

export enum ElifProperties {
  topic = 'topic',
}

export enum ImageGenerationProperties {
  subject = 'subject',
  topic = 'topic',
  design = 'design',
}

export enum PptMakerProperties {
  doc = 'doc',
  sections = 'sections',
  slideNumber = 'slideNumber',
  contentStyle = 'contentStyle',
}

export enum UnitPlanProperties {
  gradeLevel = 'gradeLevel',
  subject = 'subject',
  topic = 'topic',
  format = 'format',
  theme = 'theme',
  context = 'context',
  attributes = 'attributes',
  goals = 'goals',
}

export enum GenericUnpackingProperties {
  subject = 'guSubject',
  gradeLevel = 'guGradeLevel',
  unpackType = 'guUnpackType',
  itemToUnpack = 'guItemToUnpack',
  feature = 'feature',
}

export enum IPlanProperties {
  feature = 'feature',
}
